import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

/* attach token automatically */
API.interceptors.request.use((req) => {

    const token = localStorage.getItem("token");

    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }

    return req;
});
// ✅ ADD THIS — auto-logout when token expires (401 on any request)
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem("token");
            window.location = "/login";
        }
        return Promise.reject(error);
    }
);

/* login */
export const login = async (username, password) => {

    const res = await API.post("/auth/login", {
        username,
        password
    });

    localStorage.setItem("token", res.data.token);

    return res.data;

};

/* session list */
export const getSessions = () => API.get("/sessions");

/* session details */
export const getSessionDetails = (uuid) =>
    API.get(`/sessions/${uuid}`);

export default API;